import { render, staticRenderFns } from "./platformSoftware.vue?vue&type=template&id=1f79ec42"
import script from "./platformSoftware.vue?vue&type=script&lang=js"
export * from "./platformSoftware.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports